var React = require('react');

function IconAutoDistributionBolt (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288l111.5 0L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7l-111.5 0L349.4 44.6z"}));
}

IconAutoDistributionBolt.defaultProps = {"viewBox":"0 0 448 512","fill":"currentColor"};

module.exports = IconAutoDistributionBolt;

IconAutoDistributionBolt.default = IconAutoDistributionBolt;
